"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import PlayPauseIndicator from "./index";
import { Surface, StatusLabel } from "data:text/javascript;base64,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";
export default function PlayPauseIndicatorTestHarness() {
  const $ = _c(9);
  const [state, setState] = useState("pause");
  const [trigger, setTrigger] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setState(_temp);
      setTrigger(_temp2);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== state) {
    t1 = <StatusLabel>{state}</StatusLabel>;
    $[1] = state;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== state || $[4] !== trigger) {
    t2 = <PlayPauseIndicator state={state} trigger={trigger} />;
    $[3] = state;
    $[4] = trigger;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Surface onClick={t0}>{t1}{t2}</Surface>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp2(current_0) {
  return current_0 + 1;
}
function _temp(current) {
  return current === "play" ? "pause" : "play";
}